import MomentUtils from '@date-io/moment';
import FuseLayout from '@fuse/core/FuseLayout';
import FuseTheme from '@fuse/core/FuseTheme';
import history from '@history';
import { createGenerateClassName, jssPreset, StylesProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { create } from 'jss';
import jssExtend from 'jss-plugin-extend';
import rtl from 'jss-rtl';
import React, { useRef, useState } from 'react';
import Provider from 'react-redux/es/components/Provider';
import { Router } from 'react-router-dom';
import AppContext from './AppContext';
import { Auth } from './auth';
import routes from './fuse-configs/routesConfig';
import store from './store';
import IdleTimer from 'react-idle-timer';
import AuthService from 'app/services/authService';
import { DomainModelContext } from '../libs/domain-model-manager';
import builMessageProvider from './messageProvider';

const jss = create({
	...jssPreset(),
	plugins: [...jssPreset().plugins, jssExtend(), rtl()],
	insertionPoint: document.getElementById('jss-insertion-point')
});

const generateClassName = createGenerateClassName();

const App = () => {
	const [authService] = useState(new AuthService());
	let idleTimer = useRef();

	const onIdle = e => {
		if (idleTimer.getRemainingTime() <= 0) {
			authService.logoutRedirect();
		}
	};

	const storeDomain = builMessageProvider(store);

	return (
		<DomainModelContext.Provider value={storeDomain}>
			<AppContext.Provider
				value={{
					routes
				}}
			>
				<IdleTimer
					ref={ref => {
						idleTimer = ref;
					}}
					element={document}
					onIdle={onIdle}
					debounce={250}
					timeout={1000 * 60 * 30}
				/>
				<StylesProvider jss={jss} generateClassName={generateClassName}>
					<Provider store={store}>
						<MuiPickersUtilsProvider utils={MomentUtils}>
							<Auth>
								<Router history={history}>
									<FuseTheme>
										<FuseLayout />
									</FuseTheme>
								</Router>
							</Auth>
						</MuiPickersUtilsProvider>
					</Provider>
				</StylesProvider>
			</AppContext.Provider>
		</DomainModelContext.Provider>
	);
};

export default App;
